export default __webpack_public_path__ + "assets/ogg/922e1120dc8436c37a8574b9cd39c530.ogg";